import { render, staticRenderFns } from "./ProductOfListBrief.vue?vue&type=template&id=a6070722&scoped=true&"
import script from "./ProductOfListBrief.vue?vue&type=script&lang=js&"
export * from "./ProductOfListBrief.vue?vue&type=script&lang=js&"
import style0 from "./ProductOfListBrief.vue?vue&type=style&index=0&id=a6070722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6070722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a6070722', component.options)
    } else {
      api.reload('a6070722', component.options)
    }
    module.hot.accept("./ProductOfListBrief.vue?vue&type=template&id=a6070722&scoped=true&", function () {
      api.rerender('a6070722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop/ProductOfListBrief.vue"
export default component.exports